import { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

type Theme = "light" | "dark";

export const ThemedToastContainer = () => {
  const [theme, setTheme] = useState<Theme>("light");

  useEffect(() => {
    // Function to get the current theme from the data-theme attribute
    const getThemeFromDocument = () => {
      const dataTheme = document.documentElement.getAttribute("data-theme");
      return dataTheme === "dark" ? "dark" : "light";
    };

    // Set initial theme
    setTheme(getThemeFromDocument());

    // Watch for theme changes
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "data-theme"
        ) {
          setTheme(getThemeFromDocument());
        }
      });
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-theme"],
    });

    return () => observer.disconnect();
  }, []);

  return (
    <ToastContainer
      theme={theme}
      draggable
      draggablePercent={40}
      draggableDirection="x"
      stacked
    />
  );
};